const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/community/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/community/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildCanonicalAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { ROLLOUT_NOINDEX_ROBOTS } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_app/community/")({
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: async ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    const title = tMeta("community");
    const description = tMeta("communityDescription");
    const alts = buildCanonicalAlternates("/community");
    const url = alts.canonical;
    return {
      meta: await buildPagePreviewMetaTags({
        title,
        description,
        canonicalUrl: url
      }, {
        robots: ROLLOUT_NOINDEX_ROBOTS,
        openGraph: {
          type: "website",
          image: {
            width: "1200",
            height: "630",
            alt: "Garimpa.Club"
          }
        }
      }, {
        locale
      }),
      links: [{
        rel: "canonical",
        href: alts.canonical
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});